
import { defineComponent, PropType } from 'vue'
import { useThemeModel } from '@entities/theme'

export default defineComponent({
  name: 'BaseRadio',
  props: {
    value: {
      type: String || Number as PropType<string | number>,
      required: true,
      default: ''
    },
    id: {
      type: String || Number as PropType<string | number>,
      required: true,
      default: ''
    }
  },
  emits: ['handleClick'],

  setup () {
    const themeModel = useThemeModel()

    return {
      themeModel
    }
  },

  methods: {
    handleClick (): void {
      this.$emit('handleClick', this.id)
    }
  }
})
